export const TODAY = new Date();
export const OUT_OF_AREA_DISTANCE_IN_METER = 10 * 1000;
export const TRIP_FEES_ET = {
    IN_AREA: 27.27,
    OUT_OF_AREA: 22.73,
};
